import React from 'react';
import './Avatar.css';

const Avatar = ({ imageUrl, backgroundUrl, alt = 'Avatar' }) => {
  return (
    <div className="avatar" data-name="Avatar">
      <div className="avatar-background">
        <img src={backgroundUrl} alt="" className="avatar-bg-circle" />
      </div>
      <div className="avatar-image" data-name="Image Background Removed 1">
        <img src={imageUrl} alt={alt} />
      </div>
    </div>
  );
};

export default Avatar;

